import { DialogModalDS } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import "../../../../../i18n/i18n";

export const UpdateRestitutionModal = (props: {
  visible: boolean;
  onClose: () => void;
}) => {
  const { visible, onClose } = props;
  const { t } = useTranslation();

  return (
    <DialogModalDS
      visible={visible}
      onClose={onClose}
      title={t("fleet.vehicleSessions.sidepanel.updateRestitutionModal.title")}
    >
      <></>
    </DialogModalDS>
  );
};
